import moment from "moment";
import {
  BULK_RESCHEDULE,
  MY_VACATIONS,
  UPDATE_SCHEDULE,
  VIEW_CALENDAR,
} from "../Constants";
import {
  UPDATE_SCHEDULE_LOGS_API,
  VIEW_CALENDAR_LOGS_API,
  BULK_RESCHEDULE_LOGS_API,
  MY_VACATIONS_LOGS_API,
} from "./ViewLogsApiHandler/APIConstants";

export const convertToFilterMenuFormat = (data) => {
  let converted = [];
  data.forEach((obj) => {
    let temp = {
      ["name"]: obj.name || obj.label || obj.procedure_name,
      ["value"]: obj.value || obj.label || obj.procedure_name,
      ["id"]: obj.id,
      ["selected"]: false,
    };
    converted.push(temp);
  });
  return converted;
};
export const convertDate = (data) => {
  let date = moment(new Date(data)).format("MMM DD, YYYY");
  let time = moment(moment(new Date(data))).format("hh:mm A");
  return [date, time];
};
export const getApiUrl = (logType) => {
  switch (logType) {
    case UPDATE_SCHEDULE:
      return UPDATE_SCHEDULE_LOGS_API;
    case VIEW_CALENDAR:
      return VIEW_CALENDAR_LOGS_API;
    case MY_VACATIONS:
      return MY_VACATIONS_LOGS_API;
    case BULK_RESCHEDULE:
      return BULK_RESCHEDULE_LOGS_API;
    default:
      break;
  }
};
